var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  rx: 19,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 28,
  height: 28,
  rx: 14,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.0142 24.9858C15.9352 21.5592 21.0206 16.0356 24.7513 12.305L25.9862 13.5305C22.171 17.2334 16.6235 22.2191 13.1235 26.1236L12.0142 24.9858Z",
  fill: "#333333",
  stroke: "#333333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1465 12.2071C17.3676 16.4618 21.6232 20.6725 25.9229 24.8486L24.7938 25.9777C22.7366 23.797 20.6522 21.634 18.567 19.4813C16.4818 17.3287 14.4086 15.1544 12.2953 13.0298L13.1474 12.1967L13.1521 12.2014L13.1465 12.2071Z",
  fill: "#333333",
  stroke: "#333333"
})));
export default SvgIconClose;